import React, { Component } from 'react';
import "./listpayment.css"
class ListPayment extends Component {
    clickIfShow=()=>{
        console.log("data=>>>>>>>>",this.props.data)
        this.props.clickIfShow1(this.props.data)
    }
  render() {
    var array  = this.props.checkoutData.selectedPayment
    var total  = array.length
    // console.log("leight =====---->array", total)
    
    return (
        
            
                        //   <div className="app-list"> 
                            

                        //   </div>
                  <a   onClick={this.clickIfShow}><li className="table-row">
                        <div className="col col-1" data-label="Job Id">{this.props.checkoutData.fullname}</div>
                        <div className="col col-2" data-label="Customer Name">{this.props.checkoutData.bclass}</div>
                        <div className="col col-3" data-label="Item">{total}</div>
                        <div className="col col-3" data-label="Amount">₦{this.props.amount}</div>
                        <div className="col col-4" data-label="Payment Status">{this.props.chargeStatus}</div>
                        
                   </li> </a> 
                    

    )

}





}

export default ListPayment;


// WEBPACK FOOTER //
// ./src/component/dashboard/listpayment.js